import { openConsentPreferences } from "~/features/app/scripts/iubenda/controller";

type Props = {
  label?: string;
  className?: string;
};

export function ConsentPlaceholder({ label = "This embedded content", className }: Props) {
  return (
    <span
      className={className}
      role="group"
      aria-label={`${label} privacy preferences`}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 12,
        minHeight: 180,
        padding: 24,
        textAlign: "center",
        border: "1px solid currentColor",
      }}
    >
      <span>{label} requires experience cookies.</span>
      <button
        type="button"
        data-ouster-consent-control
        onClick={() => openConsentPreferences()}
        style={{
          padding: "8px 12px",
          border: "1px solid currentColor",
          color: "inherit",
          background: "transparent",
          font: "inherit",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        Manage Preferences
      </button>
    </span>
  );
}
